export type EditionStatusChangeRow = {
  id: string;
  status: string | null;
  name?: string;
  rankingEntityName?: string;
};

export type EditionStatusChange = {
  direction: "forward" | "backward" | "none";
  movingCount: number;
  overriddenCount: number;
  requestsCascade: boolean;
  movingRowsAreComplete: boolean;
  movingRows: EditionStatusChangeRow[];
  overriddenRows: EditionStatusChangeRow[];
};

const EDITION_STATUS_ORDER = [
  "setup",
  "researching",
  "editing",
  "ready_for_release",
  "live",
  "archived",
] as const;

const CASCADE_TRANSLATION: Record<string, string> = {
  setup: "not_started",
  researching: "researching",
  editing: "editing",
  ready_for_release: "complete",
  live: "complete",
};

function directionOf(previousStatus: string, nextStatus: string): EditionStatusChange["direction"] {
  const previousIndex = EDITION_STATUS_ORDER.indexOf(
    previousStatus as (typeof EDITION_STATUS_ORDER)[number],
  );
  const nextIndex = EDITION_STATUS_ORDER.indexOf(
    nextStatus as (typeof EDITION_STATUS_ORDER)[number],
  );

  if (previousIndex === nextIndex) {
    return "none";
  }
  return nextIndex > previousIndex ? "forward" : "backward";
}

export function describeEditionStatusChange(input: {
  previousStatus: string;
  nextStatus: string;
  rows: EditionStatusChangeRow[];
  editionStatuses?: Array<{ status: string | null }>;
}): EditionStatusChange {
  const direction = directionOf(input.previousStatus, input.nextStatus);
  const cascadeStatus = CASCADE_TRANSLATION[input.previousStatus];
  const movingRows: EditionStatusChangeRow[] = [];
  const overriddenRows: EditionStatusChangeRow[] = [];
  for (const row of input.rows) {
    if (row.status === cascadeStatus) {
      movingRows.push(row);
    } else {
      overriddenRows.push(row);
    }
  }

  let movingCount = movingRows.length;
  let overriddenCount = overriddenRows.length;
  if (input.editionStatuses) {
    movingCount = 0;
    overriddenCount = 0;
    for (const row of input.editionStatuses) {
      if (row.status === cascadeStatus) {
        movingCount += 1;
      } else {
        overriddenCount += 1;
      }
    }
  }

  return {
    direction,
    movingCount,
    overriddenCount,
    requestsCascade: direction === "backward",
    movingRowsAreComplete: cascadeStatus === "complete",
    movingRows,
    overriddenRows,
  };
}
